module.exports = __webpack_public_path__ + "img/sound.848a3983.svg";